import firebase from 'firebase/app'

require("firebase/auth");
require("firebase/database");
require("firebase/storage");

const dataApp = firebase.initializeApp({
	"apiKey": process.env.REACT_APP_FIREBASE_APIKEY,
	"authDomain": process.env.REACT_APP_FIREBASE_AUTHDOMAIN,
	"databaseURL": process.env.REACT_APP_FIREBASE_DATABASEURL,
	"projectId": process.env.REACT_APP_FIREBASE_PROJECTID,
	"storageBucket": process.env.REACT_APP_FIREBASE_STORAGEBUCKET,
	"messagingSenderId": process.env.REACT_APP_FIREBASE_MESSAGINGSENDERID,
}, "dataApp");

export const auth = dataApp.auth();
export const database = dataApp.database();
export const storage = dataApp.storage();

/* authenticate app */
export async function authenticateApp() {
	const email = 'showroom@sensotix.com';
	const password = 'showroom$93Dnya';

	if (auth.currentUser) await auth.signOut();

	return auth.signInWithEmailAndPassword(email, password).then(() => {
		console.log('Logged in with uid ' + auth.currentUser.uid);
	})
}

/* export functions */

// get global statistics
export function onGlobalStatsUpdate(cb) {
	database.ref("/statistics").on('value', snapStats => cb(snapStats.val()));
}

// get global log
export function onGlobalAccessLogUpdate(cb) {
	database.ref("/logs/access").on('value', snapLog => {
		cb(snapLog.val());
	});
}

let initializedStickers = []; // ignore initial load, just watch for updates
export function onStickerAccessLogUpdate(stickerId, cb) {
	database.ref(`/stickers/${stickerId}/logs/access`).on('value', snapLog => {
		if (!initializedStickers.includes(stickerId)) {
			initializedStickers.push(stickerId);
		} else {
			cb(stickerId, snapLog.val());
		}
	});
}


// WEBPACK FOOTER //
// ./src/db/firebase/data.js